import webSee from '@websee/core';
export const isUseMonitor = () => {
    const VITE_REPORT_ERROR = import.meta.env.VITE_REPORT_ERROR;
    return VITE_REPORT_ERROR === 'true';
};

export const log = (type: string, info?: { [key: string]: any }) => {
    if (isUseMonitor()) {
        webSee.log({
            type: type,
            message: info || undefined,
        });
    }
};
